module.exports = __webpack_public_path__ + "img/tj3.bece22a5.png";